import React from 'react';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import { useOverlayContext } from '../../../hooks/useOverlayContext';
import { getSource, isGifDeviation, isMultiImageDeviation, isVideoDeviation } from '../../../_helpers';
import { useDeviationBlockType } from '../../hooks/useDeviationBlockType';
import DeviationThumbStatusIndicators from '../DeviationThumbIndicators';
function getMediaType(deviation) {
    if (isVideoDeviation(deviation)) {
        return 'video';
    }
    if (isGifDeviation(deviation)) {
        return 'gif';
    }
}
function getDuration(deviation) {
    const videoFile = getSource(DeviationMediaService.getMediaByType(deviation, 'video'));
    return videoFile === null || videoFile === void 0 ? void 0 : videoFile.duration;
}
const DeviationThumbOverlayDefault = ({ deviation, width, height, isFaved, hasCommentedOn, children, className })=>{
    const multi_file_deviation = useFlag('multi_file_deviation');
    const blockType = useDeviationBlockType(deviation);
    const { showPermanentEngagementIcon, showMediaIndicators } = useOverlayContext(deviation);
    return /*#__PURE__*/ React.createElement(ThumbOverlayDefault, {
        width: width,
        height: height,
        isFaved: showPermanentEngagementIcon && isFaved,
        isCommented: showPermanentEngagementIcon && hasCommentedOn,
        isMultiImage: multi_file_deviation && isMultiImageDeviation(deviation),
        statusIndicators: !blockType && /*#__PURE__*/ React.createElement(DeviationThumbStatusIndicators, {
            deviation: deviation
        }),
        mediaIndicator: showMediaIndicators && !blockType ? getMediaType(deviation) : undefined,
        duration: getDuration(deviation),
        className: className
    }, children);
};
DeviationThumbOverlayDefault.displayName = 'DeviationThumbOverlayDefault';
export default DeviationThumbOverlayDefault;

//# sourceMappingURL=DeviationThumbOverlayDefault.js.map